export default __webpack_public_path__ + "static/media/cancel-grey.732c2b7f.svg";